import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#292A2E",
      d: "m6.228 12.521-1.287-.345.524-1.96A7.3 7.3 0 0 1 3.307 8.97l-1.435 1.436-.943-.944 1.436-1.435a7.3 7.3 0 0 1-1.581-3.38l1.312-.24a6.002 6.002 0 0 0 11.808 0l1.312.24a7.3 7.3 0 0 1-1.58 3.38l1.435 1.435-.943.944-1.435-1.436a7.3 7.3 0 0 1-2.158 1.248l.524 1.96-1.287.344-.525-1.96a7.4 7.4 0 0 1-2.494 0z"
    }, null, -1)
  ]))]))
}
export default { render: render }